var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserClients(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 28,
    viewBox: "0 0 40 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 27,
    rx: 4.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0329 21.6004C25.0329 19.9214 22.7797 18.5604 20.0002 18.5604C17.2208 18.5604 14.9675 19.9214 14.9675 21.6004M29.0591 18.5608C29.0591 17.3142 27.8169 16.2428 26.0394 15.7737M10.9414 18.5608C10.9414 17.3142 12.1836 16.2428 13.961 15.7737M26.0394 11.7063C26.6572 11.1497 27.046 10.3407 27.046 9.44039C27.046 7.76145 25.6941 6.40039 24.0264 6.40039C23.253 6.40039 22.5476 6.69309 22.0133 7.17447M13.961 11.7063C13.3433 11.1497 12.9545 10.3407 12.9545 9.44039C12.9545 7.76145 14.3064 6.40039 15.9741 6.40039C16.7475 6.40039 17.4529 6.69309 17.9872 7.17447M20.0002 15.5204C18.3325 15.5204 16.9806 14.1594 16.9806 12.4804C16.9806 10.8015 18.3325 9.44039 20.0002 9.44039C21.668 9.44039 23.0198 10.8015 23.0198 12.4804C23.0198 14.1594 21.668 15.5204 20.0002 15.5204Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserClients);
export default __webpack_public_path__ + "static/media/UserClients.ca67dfd34506a70e19ae6a7c03e502ec.svg";
export { ForwardRef as ReactComponent };